module.exports = __webpack_public_path__ + "img/default.add609c0.jpg";